import React from 'react'
import { Refinement } from 'lib/Refinement/types'

import CustomPriceBucketRefinementList from 'components/Filters/PriceBucketFilter/CustomPriceBucketRefinementList'

export const KEY = 'publicFilters.price.rangesInCents'

export const priceFilterRefinement: Refinement = {
  getQueryParamValue: ({ refinementList }) =>
    refinementList &&
    refinementList[KEY] && { price: refinementList[KEY].join('_') },
  getStateValue: ({ price }) =>
    price && { refinementList: { [KEY]: (price as string).split('_') } },
}

const PriceBucketFilter = (): JSX.Element => (
  <CustomPriceBucketRefinementList attribute={KEY} />
)

export default PriceBucketFilter
